import { AlertMessageModel } from '../models/alert-message.model';
import { SeverityTypeEnum } from '../enums/severity-type.enum';
import { AlertContextEnum } from '../enums/alert-context.enum';

export class AlertMessageFactory {
  static create(payload: any, type: SeverityTypeEnum, context: AlertContextEnum = AlertContextEnum.Global): AlertMessageModel[] {
    const target: string | undefined = payload.target;

    let fr = payload.i18n?.fr ?? '';
    let en = payload.i18n?.en ?? '';

    if (fr === '') {
      switch (type) {
        case SeverityTypeEnum.Error:
          fr = 'Une erreur est survenue, veuillez réessayer plus tard. Si le problème persiste, utilisez l\'icône de clavardage en bas à droite pour nous contacter.';
          break;
      }
    }

    if (en === '') {
      switch (type) {
        case SeverityTypeEnum.Error:
          en = 'An unknown error has occurred, please retry later. If the problem persists, please use the chat icon at the bottom right to contact us for support.';
          break;
      }
    }

    if (payload.status === 404) {
      fr = 'La resource que vous tentez d\'accèder n\'existe pas ou a été supprimée.';
      en = 'The resource you are trying to acces does not exist or has been deleted.';
    }

    const alertMessage = new AlertMessageModel(type, context, { fr, en });
    alertMessage.target = target;

    return [alertMessage];
  }

  static createValidationAlertMessage(validationError: any, type: SeverityTypeEnum): AlertMessageModel[] {

    if (!validationError?.error?.errors && validationError?.error?.errors.length < 1) {
      return [];
    }

    let errorMessage = 'Some validation errors happened:';
    for (const error of validationError.error.errors) {
      if (!error.constraints) {
        continue;
      }
      for (const key in error.constraints) {
        errorMessage += '\n ' + error.constraints[key] + '; \n';
      }
    }

    const alertMessage = new AlertMessageModel(type, AlertContextEnum.Global, { fr: errorMessage, en: errorMessage });
    // alertMessage.target = target;

    return [alertMessage];
  }
}